import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { removeTestimonials } from "./api";
import { invalidateAllQueries } from "utils/utils";

export function useRemoveTestimonials({ ...options } = {}) {
    return useMutation({
        mutationFn: ({ id }) => removeTestimonials(id),
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Removed testimonial Successfully");
            options.onSuccess?.();
        },
        onError: () => {
            toast.error("Error Removing testimonial");
        },
    });
}